module.exports = __webpack_public_path__ + "img/3D.4bb06da6.png";